const defaultColumn = {
  size: 'auto',
}

export {
  defaultColumn
}
